module.exports = __webpack_public_path__ + "static/background2-5b717543d0f82868521d611d26338f1d.jpg";